import { render, staticRenderFns } from "./dynamicComponent.vue?vue&type=template&id=1e47c794&scoped=true&"
import script from "./dynamicComponent.vue?vue&type=script&lang=js&"
export * from "./dynamicComponent.vue?vue&type=script&lang=js&"
import style0 from "./dynamicComponent.vue?vue&type=style&index=0&id=1e47c794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e47c794",
  null
  
)

export default component.exports